import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const Margin = ({ children, className }) => (
  <div
    className={twMerge(
      // max-w alargado em 50px em relação aos breakpoints padrão do
      // Tailwind (screen-lg=1024, screen-xl=1280) pra dar mais respiro
      // pro card da oferta — aplicado a TODO FlatLayout.Margin.
      'group/layout relative mx-auto my-0 mb-16 grid w-full lg:max-w-[1074px] lg:grid-cols-16 lg:px-4 xl:max-w-[1330px] xl:px-0 [&:not(:has(>[data-heading=true]))]:pt-4 lg:[&:not(:has(>[data-heading=true]))]:pt-14 [&_*]:font-rubik',
      className
    )}
    data-global-flatbg
  >
    {children}
  </div>
);

Margin.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Margin;
